export enum CompanyType {
  Brand = 'Brand',
  Agency = 'Agency',
}
